import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import MainLayout from '../../Layout/MainLayout';
import PageContainer from '../../components/layout/PageContainer';
import PostTripHeader from './sections/Header/PostTripHeader';
import PostTripTabs from './sections/Header/PostTripTabs';
import PackagesTab from './sections/Packages/PackagesTab';
import EnquiriesTab from './sections/Enquiries/EnquiriesTab';
import NotificationsTab from './sections/Notifications/NotificationsTab';

const tabVariants = {
    hidden: { opacity: 0, y: 12 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.25, ease: 'easeOut' } },
    exit: { opacity: 0, y: -8, transition: { duration: 0.15, ease: 'easeIn' } }
};

const PostTripConnectPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const getInitialTab = () => {
        if (location.pathname === '/enquiries') return 'enquiries';
        if (location.pathname === '/notifications') return 'notifications';
        return 'packages';
    };

    const [activeTab, setActiveTab] = useState(getInitialTab());
    const [showCreateModal, setShowCreateModal] = useState(false);

    useEffect(() => {
        setActiveTab(getInitialTab());
    }, [location.pathname]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        if (tab === 'packages') {
            navigate('/post-connect');
        } else {
            navigate(`/${tab}`);
        }
    };

    return (
        <MainLayout activeTab={activeTab === 'packages' ? 'post-connect' : activeTab}>
            <PageContainer>
                {/* Header */}
                <PostTripHeader
                    activeTab={activeTab}
                    onAddPackage={() => setShowCreateModal(true)}
                />

                {/* Tabs */}
                <PostTripTabs
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                />

                {/* Content with Animation */}
                <AnimatePresence mode="wait">
                    <motion.div
                        key={activeTab}
                        variants={tabVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                    >
                        {activeTab === 'packages' && (
                            <PackagesTab
                                showCreateModal={showCreateModal}
                                setShowCreateModal={setShowCreateModal}
                            />
                        )}

                        {activeTab === 'enquiries' && (
                            <EnquiriesTab />
                        )}

                        {activeTab === 'notifications' && (
                            <NotificationsTab />
                        )}
                    </motion.div>
                </AnimatePresence>
            </PageContainer>
        </MainLayout>
    );
};

export default PostTripConnectPage;
